/**
 * ******************************************************************************************
 * Small component to display useful for displaying status or category information. If an icon
 * is desired pass the corresponding font-awesome class name to the iconLeft or iconRight
 * props. 🐺
 * **********
 *
 * @format
 */

import PropTypes from 'prop-types';
import React from 'react';

export const Tag = props => {
    const {className, iconLeft, iconRight, children, color = ''} = props;
    let typeClass = 'tag-type-default';

    return (
        <div className={`common-tag-17zx ${typeClass} ${className}`} style={{borderColor: color}}>
            {iconLeft && (
                <i className={`common-tag-17zx__icon--left fa ${iconLeft}`} style={{color}} />
            )}
            <div style={{color}} className="common-tag-17zx__content">
                {children}
            </div>
            {iconRight && (
                <i className={`common-tag-17zx__icon--right fa ${iconRight}`} style={{color}} />
            )}
        </div>
    );
};

// Prop types
Tag.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    color: PropTypes.string,
    iconLeft: PropTypes.string,
    iconRight: PropTypes.string
};
